module.exports = ".card {\r\n    margin-bottom:30px;\r\n}\r\n.card-footer{\r\n    padding:0px;\r\n}\r\n.card-footer button{\r\n    cursor: pointer;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/product-card/product-card.component.css
// module id = ./src/app/shared/components/product-card/product-card.component.css
// module chunks = main